import {
  GET_USERS,
  USERS_ERROR,
  USER_DETAIL,
  USER_LIST,
  USER_FILTERDETAIL,
  ADD_USERS,
  EDIT_USER,
  USERSTATUS_UPDATE,
  USER_ROLE_AND_PARENT_CHANGE,
  GET_PARENT_USERLIST,
  USER_DETAILS_FOR_VISITOR
} from "../types";
import userService from "../service/userService";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";

export const getUserList = (item) => async (dispatch) => {
  try {
    const res = await userService.getUserList(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: USER_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const editUser = (item) => async (dispatch) => {
  try {
    const res = await userService.editUser(item);
    if (res.data.status === 200) {
      dispatch({
        type: EDIT_USER,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getUserDetail = (item) => async (dispatch) => {
  try {
    const res = await userService.getUserDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getUserFilterDetail = (item) => async (dispatch) => {
  try {
    const res = await userService.getUserFilterDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_FILTERDETAIL,
        payload: res.data,
      });
    } else {
      dispatch({
        type: USER_FILTERDETAIL,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const createUser = (item) => async (dispatch) => {
  try {
    const res = await userService.createUser(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_USERS,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const userStatusUpdate = (item) => async (dispatch) => {
  try {
    const res = await userService.userStatusUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: USERSTATUS_UPDATE,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const userRoleAndParentChange = (item) => async (dispatch) => {
  try {
    const res = await userService.userRoleAndParentChange(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_ROLE_AND_PARENT_CHANGE,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const userPasswordGenrate = (item) => async (dispatch) => {
  try {
    const res = await userService.userPasswordGenrate(item);
    if (res.data.status === 200) {
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const parentUserList = (item) => async (dispatch) => {
  try {
    const res = await userService.ParentUserList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_PARENT_USERLIST,
        payload: res.data,
      });
      // successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getUserDetailForVisitor = (item) => async (dispatch) => {
  try {
    const res = await userService.userDetailsForVisitor(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_DETAILS_FOR_VISITOR,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};